import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SingleLabType {
    lab_id: boolean | null,
    radio_id: boolean | null,
    Name_lab_radio: string | null;

    // resultRequst page
    lab_rsult_request: boolean | null;
    radio_result_request: boolean | null;

}

const initialState: SingleLabType = {
    lab_id: false,
    radio_id: null,
    Name_lab_radio: null,
    lab_rsult_request: false,
    radio_result_request : false
}

export const setSingle_lab = createSlice({
    name: 'single_lab',
    initialState,
    reducers: {
        set_lab_id: (state, action) => {
            state.lab_id = action.payload
        },
        set_radio_id: (state, action) => {
            state.radio_id = action.payload
        },
        setNameLab_radio: (state, action) => {
            state.Name_lab_radio = action.payload
        },
        set_LaboratoryResult_Request: (state, action: PayloadAction<boolean>) => {
            state.lab_rsult_request = action.payload
        },
        set_RadioLogyResult_Request: (state, action: PayloadAction<boolean>) => {
            state.radio_result_request = action.payload
        }
    }
})

export const { set_lab_id, set_radio_id, setNameLab_radio,set_RadioLogyResult_Request,set_LaboratoryResult_Request } = setSingle_lab.actions;
export default setSingle_lab.reducer;